import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import ctaImage from "../assets/images/solar/8.png";

export default function Cta() {
  const [isOpen, setOpen] = useState(false);

  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      {/* Advanced Background Design */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-teal-900 to-emerald-900">
        {/* Animated Background Elements */}
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl animate-pulse-slow" style={{animationDelay: '2s'}}></div>
        
        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:64px_64px]"></div>
      </div>

      <div className="container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content Section */}
          <div className="text-white">
            {/* Badge */}
          

            {/* Main Heading */}
            <h2 className="font-bold text-4xl lg:text-5xl xl:text-6xl leading-tight mb-6">
              See Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-emerald-300">Impact</span> in Action
            </h2>

            {/* Description */}
            <p className="text-slate-200 text-lg lg:text-xl leading-relaxed mb-8 max-w-2xl">
              Discover how RENERG is transforming Rwanda's energy landscape through innovative solar solutions, sustainable development, and community empowerment.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                <div className="text-2xl lg:text-3xl font-bold text-teal-300 mb-1">15+</div>
                <div className="text-slate-300 text-sm font-medium">Years Experience</div>
              </div>
              <div className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                <div className="text-2xl lg:text-3xl font-bold text-emerald-300 mb-1">1.3GW+</div>
                <div className="text-slate-300 text-sm font-medium">Solar Projects</div>
              </div>
              <div className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                <div className="text-2xl lg:text-3xl font-bold text-teal-300 mb-1">12+</div>
                <div className="text-slate-300 text-sm font-medium">Countries</div>
              </div>
            </div>

            {/* Additional CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setOpen(true)}
                className="group inline-flex items-center justify-center h-14 px-8 font-semibold rounded-xl bg-gradient-to-r from-teal-500 to-emerald-600 text-white shadow-2xl shadow-teal-500/25 hover:shadow-2xl hover:shadow-teal-500/40 hover:scale-105 transition-all duration-300"
              >
                <span className="mr-3 text-xl">▶</span>
                Watch Our Story
                <i className="mdi mdi-arrow-right align-middle ms-2 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
              </button>
              
           
            </div>
          </div>

          {/* Video Thumbnail Section */}
          <div className="relative">
            {/* Main Image Container */}
            <div className="relative group cursor-pointer" onClick={() => setOpen(true)}>
              {/* Image with Gradient Overlay */}
              <div className="relative overflow-hidden rounded-3xl shadow-2xl shadow-black/30">
                <img 
                  className="w-full h-auto transform group-hover:scale-110 transition-transform duration-700" 
                  src={ctaImage} 
                  alt="RENERG Impact Video" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-900/40 via-transparent to-emerald-900/30"></div>
                
                {/* Play Button Container */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                    {/* Animated Ring Effect */}
                    <div className="absolute inset-0 animate-ping-slow">
                      <div className="size-24 bg-teal-400/30 rounded-full blur-sm"></div>
                    </div>
                    
                    {/* Main Play Button */}
                    <div className="relative size-20 bg-gradient-to-br from-teal-400 to-emerald-500 rounded-full shadow-2xl shadow-teal-500/50 flex items-center justify-center transform group-hover:scale-110 transition-all duration-300 group-hover:rotate-12">
                      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full"></div>
                      <span className="text-white text-2xl ml-1">▶</span>
                    </div>
                  </div>
                </div>

                {/* Hover Text */}
                <div className="absolute bottom-8 left-8 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500">
                  <div className="text-white font-semibold text-lg backdrop-blur-sm bg-black/30 px-4 py-2 rounded-xl">
                    Click to watch our journey
                  </div>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-8 h-8 bg-teal-400 rounded-full animate-bounce"></div>
              <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-emerald-400 rounded-full animate-bounce" style={{animationDelay: '1s'}}></div>
            </div>

            {/* Background Decorative Elements */}
            <div className="absolute -z-10 -inset-8">
              <div className="w-full h-full border-2 border-teal-500/20 rounded-3xl rotate-3"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-teal-500/5 rounded-3xl blur-xl"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Video */}
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 1 }}
        isOpen={isOpen}
        videoId="YOUR_VIDEO_ID" // Replace with your actual video ID
        onClose={() => setOpen(false)}
      />

      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }
        .animate-pulse-slow {
          animation: pulse-slow 6s ease-in-out infinite;
        }
        @keyframes ping-slow {
          75%, 100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }
        .animate-ping-slow {
          animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
      `}</style>
    </section>
  );
}
// import React, { useState } from "react";
// import ModalVideo from "react-modal-video";
// import "react-modal-video/scss/modal-video.scss";
// import ctaImage from "../assets/images/solar/8.png";

// export default function Cta() {
//   const [isOpen, setOpen] = useState(false);

//   return (
//     <section className="relative md:py-24 py-16 md:pt-0 pt-0">
//       <div className="container relative">
//         <div className="grid grid-cols-1 justify-center">
//           <div className="relative z-1">
//             <div className="grid grid-cols-1 md:text-start text-center justify-center">
//               <div className="relative">
//                 <img className="rounded-[5em]" src={ctaImage} alt="" />
//                 <div className="absolute bottom-2/4 translate-y-2/4 start-0 end-0 text-center">
//                   <button
//                     onClick={() => setOpen(true)}
//                     className="lightbox size-20 rounded-full shadow-lg dark:shadow-gray-700 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-teal-500 dark:text-white"
//                   >
//                     <i className="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
//                   </button>
//                 </div>
//                 <ModalVideo
//                   channel="youtube"
//                   youtube={{ mute: 0, autoplay: 1 }}
//                   isOpen={isOpen}
//                   videoId="#" // Replace with your video ID
//                   onClose={() => setOpen(false)}
//                 />
//               </div>
//             </div>
//             <div className="content md:mt-8">
//               <div className="grid lg:grid-cols-12 grid-cols-1 md:text-start text-center justify-center">
//                 <div className="lg:col-start-2 lg:col-span-10">
//                   <div className="grid md:grid-cols-2 grid-cols-1 items-center"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="absolute bottom-0 start-0 end-0 sm:h-2/3 h-4/5 bg-gradient-to-b from-teal-400 to-teal-500"></div>
//     </section>
//   );
// }
